import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Dashboard from './Dashboard.js';
import Admin from './Admin.js';
import ManageBranches from './ManageBranches';
import LoginForm from './LoginForm.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import ChangePassword from './ChangePassword';
import Opentabs1 from './opentabs';
import SessionProvider from './providers/SessionProvider';
import ForgetPassword1 from './ForgetPassword1.js';
import ForgetPasswordDr from './ForgetPasswordDr.js';


function App() {
  return (
    <SessionProvider>
    <Router>
      
        <Routes>
		  <Route path="/" element={<LoginForm />} />
          <Route path="/dashboard" element={<Dashboard />} />
          {/* <Route path="/logout" element={<Logout />} /> */}
		  <Route path="/change_password" element={<ChangePassword />} />
		  <Route path="/manage_branches" element={<ManageBranches />} />
      <Route path="/opentabs" element={<Opentabs1 />} />
      <Route path="/forget-password" element={<ForgetPassword1 />} />
      <Route path="/forget-password_for_dr" element={<ForgetPasswordDr />} />
          {/* You can add more routes here */}
        </Routes>
      
    </Router>
    </SessionProvider>
  );
}

export default App;